/**
 * Class description
 *
 * Created: 2019-08-30
 * @author jonas
 */
import {Timeline, TimelineLite} from "gsap";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {SpacierArcadeParsedGameData} from "../server/data/SpacierArcadeParsedGameData";
import {SpacierArcadeGameModuleConfig} from "../SpacierArcadeGameModuleConfig";
import {SpacierArcadeModeData} from "../server/data/SpacierArcadeModeData";
import {ISymbolStateConfig, StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {SASymbols} from "../symbols/SpacierArcadeReelSymbol";
import {SpacierArcadeGameConfig} from "../SpacierArcadeGameConfig";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {SAReelEvent} from "../reel/SAReelController";
import {SpacierArcade} from "../SpacierArcade";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {GameSetting} from "@nolimitcity/slot-game/bin/core/setting/GameSetting";
import {SpacierArcadeSoundConfig} from "../SpacierArcadeSoundConfig";

export class ScatterReelAttention implements GameRoundPresentation {
    private readonly _reelId:number;
    private readonly _duration:number;
    private readonly _abortDuration:number;
    private _tl:TimelineLite;

    constructor(reelId:number, duration:number, abortDuration:number) {
        this._reelId = reelId;
        this._duration = duration;
        this._abortDuration = abortDuration;
    }

    public getAnimation(data:SpacierArcadeParsedGameData):Timeline | null {
        if(data.nearWinReels[this._reelId]) {
            this._tl = SpacierArcade.timelineReelsController.startNearWin(this._reelId, this._duration);
            this._tl.add([
                () => SpacierArcadeGameModuleConfig.saScatterAttentionView.playNearWin(this._reelId),
                this.changeSymbolState(SpacierArcadeGameConfig.instance.SYMBOL_STATES.noWin),
                () => EventHandler.dispatchEvent(new GameEvent(SAReelEvent.UPDATE_NEAR_REEL_VIEW)),
                () => SlotGame.sound.playEffect(SpacierArcadeSoundConfig.instance.ANTICIPATION_SCATTER)
            ], GameSetting.isFastSpin? 0.5 : 0);
            return this._tl;
        }
        return null;
    }

    private changeSymbolState(state:ISymbolStateConfig):TimelineLite{
        const tl:TimelineLite = new TimelineLite();
        tl.add(() => {
            [0, 4].forEach((reelId: number) => {
                let reelSymbols: (StateReelSymbol | null)[] = Reels.allSymbols(reelId);
                reelSymbols.forEach((sym: StateReelSymbol | null) => {
                    if (sym) {
                        sym.changeState({
                            state: state
                        })
                    }
                });
            });
        });
        return tl;
    }

}